import 'babel-polyfill'
import Vue from 'vue'
import Axios from 'axios'

import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

import './stylus/main.styl'

Vue.config.productionTip = false
Axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL

Axios.interceptors.request.use(
  config => {
    let token = localStorage.getItem('access_token')

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    return config
  },

  error => {
    return Promise.reject(error)
  }
)

Axios.interceptors.response.use(
  response => {
    return Promise.resolve(response)
  },

  error => {
    if (error.response.data === 'Unauthorized') {
      localStorage.clear()
      location.href = '/login'
    }
    return Promise.reject(error)
  }
)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
